import { ThemeContextProvider } from '@/contexts/ThemeContext'
import { ContentOnlyLayout } from '@/layouts/ContentOnlyLayout'
import { NextPageWithLayout } from '@/layouts/types'
import { getGuildStatus } from '@/services/GuildUserService/GuildUserService'
import { getServerSidePropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { loadTranslations } from '@/utils/translate/translate-server'
import { SignUpPickerView } from '@/views/SignUpPickerView'

export const SignUpHome: NextPageWithLayout = () => {
  return (
    <ThemeContextProvider isDarkMode>
      <SignUpPickerView />
    </ThemeContextProvider>
  )
}

export const getServerSideProps = getServerSidePropsErrorHandler(async ({ locale, federationClient }) => {
  const guildStatus = await getGuildStatus(federationClient)

  if (guildStatus && guildStatus.isGuildMember) {
    return {
      redirect: {
        destination: '/guild',
        permanent: false,
      },
    }
  }

  return {
    props: {
      locale,
      ...(await loadTranslations(locale, ['common', 'sign-up'])),
    },
  }
})

SignUpHome.getLayout = (page) => {
  return <ContentOnlyLayout>{page}</ContentOnlyLayout>
}

export default SignUpHome
